import { createRequestSummaryInfo, RequestSummaryInfo } from "../common"
import { RequestModel } from "./types"

export const requestSummaryInfo = (data: RequestModel): RequestSummaryInfo => {
    const summary: RequestSummaryInfo = createRequestSummaryInfo(data)

    return summary
}
